/*
 * SendQuestionnaires Messages
 *
 * This contains all the text for the SendQuestionnaires component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.SendQuestionnaires';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Send questionnaires',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Send',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
});
